(() => {
  if (window.__velkynGalleryHoverV2) return;
  window.__velkynGalleryHoverV2 = true;

  const canHover = window.matchMedia('(hover: hover) and (pointer: fine)');

  const enhance = (root = document) => {
    const galleries = root.querySelectorAll
      ? root.querySelectorAll(".product-information media-gallery[data-presentation='carousel']")
      : [];

    galleries.forEach((gallery) => {
      if (gallery.dataset.velkynHoverReady === 'true') return;
      gallery.dataset.velkynHoverReady = 'true';

      gallery.addEventListener('pointerover', (event) => {
        if (!canHover.matches || !(event.target instanceof Element)) return;

        const thumbnail = event.target.closest('.slideshow-controls__thumbnail');
        if (!thumbnail || !gallery.contains(thumbnail)) return;
        if (event.relatedTarget instanceof Node && thumbnail.contains(event.relatedTarget)) return;
        if (thumbnail.getAttribute('aria-selected') === 'true') return;

        thumbnail.click();
      });
    });
  };

  const start = () => enhance(document);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', start);
  new MutationObserver(start).observe(document.documentElement, { childList: true, subtree: true });
})();
